import { graphql } from '@/generated/gql';

export const NEGOTIATION_CASE_DETAIL_STATUS_WIDGET_QUOTE_QUERY = graphql(/* GraphQL */ `
  query NegotiationCaseDetailQuote($id: UUID!) {
    tesseract {
      negotiationCase(id: $id) {
        id
        status
        cancellationReason
        cancellationReasonText
        options {
          id
          supplierInteractionMode
        }
        isMaskedBidding
        negotiatedQuote {
          id
          createdAt
          currency
          totalValue
          discount
          lineItems {
            id
            supplierComment {
              variant
              text
            }
          }
          totalDiscountedValue
          totalPriceDiscount
          supplierComment {
            text
            variant
          }
        }
      }
    }
  }
`);
